import { Route } from '@angular/router';
import { AuthGuard } from '@app/core/authentication';
import { MainLayoutComponent } from '@app/shared/components';
import { routeAccess } from './config/config';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: routeAccess.allRoles },
    children: [
      /**
       * * Upload
       */
      {
        path: 'upload',
        loadChildren: () => import('@app/upload-file').then((m) => m.UploadFileModule),
      },
      {
        path: 'invoices',
        loadChildren: () => import('@app/invoices').then((m) => m.InvoicesModule),
      },
      /**
       * * Users
       */
      // {
      //   path: "users",
      //   loadChildren: () =>
      //     import("@app/core/users").then((m) => m.CoreUsersModule),
      // },
      /**
       * * Administration
       */
      // {
      //   path: "administration",
      //   loadChildren: () => import("@app/clients").then((m) => m.ClientsModule),
      // },
      { path: '', redirectTo: 'upload', pathMatch: 'full' }, // Redirect to orders
      { path: '**', redirectTo: 'login', pathMatch: 'full' }, // redirect to home
    ],
  },
  {
    path: 'login',
    loadChildren: () => import('@app/core/authentication').then((m) => m.CoreAuthenticationModule),
  },
  { path: '**', redirectTo: 'admins' }, // redirect to home
];
